import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import config from 'config/api';
import i18n from 'helpers/i18n';
import { withStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import clsx from 'clsx';
import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
import Header from 'components/Header/Header';
import Banner from 'components/Banner/Banner';
import AccountSettingsForm from './AccountSettingsForm';
import Typography from '@material-ui/core/Typography';
import { isLoggedIn, getCurrentUserRole } from 'ducks/authentication';
import { fetchData, getDataHome } from 'ducks/asyncFetcher';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Fade from '@material-ui/core/Fade';
import Footer from '../Footer';
import Template from 'components/Template/Template';
const AF_KEY = 'home';

const styles = (theme) => {
  return {
    root: {
      minHeight: '100%',
      // display: "flex",
      // flexDirection: "column",
      // "& > *": {
      //   flex: 1,
      // },
    },
    pageTitle: {
      paddingTop: 16,
      // paddingBottom: 16,
      // color: theme.palette.primary.main,
      // textAlign: 'center',
      // fontSize: '2.2rem',
      // backgroundColor: '#fff',
      // marginTop: theme.spacing(2),
      // marginBottom: theme.spacing(2),
      // paddingLeft: theme.spacing(2),
      // paddingRight: theme.spacing(2),
      // boxShadow: theme.shadows[3],
      // [theme.breakpoints.down('md')]: {
      //   fontSize: '1.8rem',
      // },
      // [theme.breakpoints.down('sm')]: {
      //   fontSize: '1.5rem',
      // },
      // [theme.breakpoints.down('xs')]: {
      //   fontSize: '1.3rem',
      // },
    },

    whiteBg: {
      // position: 'relative',
      // marginBottom: theme.spacing(4),
      // '&:before': {
      //   position: 'absolute',
      //   left: 0,
      //   top: 0,
      //   content: "' '",
      //   width: '100%',
      //   height: '100%',
      //   backgroundColor: theme.palette.background.paper,
      //   opacity: 0.9,
      // },
    },

    paper: {
      padding: theme.spacing(4),
      // backgroundColor: 'transparent',
    },
  };
};

class Account extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // tabSelected: 0
    };
    this._onSubscriptionComplete = this._onSubscriptionComplete.bind(this);
    this._onClose = this._onClose.bind(this);
  }

  componentDidMount() {
    this.props.onMount();
  }

  _onSubscriptionComplete() {
    this.props.onMount();
  }
  _onClose() {
    const { history } = this.props;
    history.push('/');
  }
  render() {
    const { onPanelToggle, classes, userRole, isLoggedIn, $$data } = this.props;

    if (!isLoggedIn) {
      return (
        <Redirect
          to={{
            pathname: '/',
            state: { from: this.props.location },
          }}
        />
      );
    }

    return (
      <Template  headerImage="background" fixedSizeThreshold={712}>
        <Fade in timeout={1000} style={{ width: '100%' }}>
          <div className={classes.root}>
            <Typography variant="h2" className={classes.pageTitle}>
              {i18n.get('accountFormTitle')}
            </Typography>{' '}
            <Box className={clsx(classes.paperWrapper, classes.whiteBg)}>
              <Paper square elevation={0} className={classes.paper}>
                <Box className={classes.paperWrapper}>
                  <Paper square elevation={0} className={classes.paper}>
                    <Choose>
                      <When condition={isLoggedIn && $$data !== undefined}>
                        <AccountSettingsForm onFormCancel={this._onClose} />
                      </When>
                    </Choose>
                  </Paper>
                </Box>
              </Paper>
            </Box>
            <Banner />
          </div>
        </Fade>
      </Template>
    );
  }
}
function mapStateToProps(state) {
  const props = {
    $$data: getDataHome(state),
    isLoggedIn: isLoggedIn(state),
    userRole: getCurrentUserRole(state),
  };
  return props;
}
function mapDispatchToProps(dispatch) {
  return {
    onMount: () => {
      dispatch(fetchData({ key: AF_KEY, fetchUrl: config.home }));
    },
  };
}

export default withStyles(styles)(withRouter(connect(mapStateToProps, mapDispatchToProps)(Account)));



// WEBPACK FOOTER //
// ./src/components/Account/Account.jsx